'use memo';

import { useEffect, useMemo } from 'react';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { TaskModalPageProps } from '../TaskModalPageProps';
import QLDAgreementTypeStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/QLD/QLDAgreementTypeStageSteps';
import { getQldAgreementTypeStepCompletionValues } from '../agreementComplianceValidation';

const QldAgreementComplianceTypePage = ({
  task,
  toggleTaskStep,
  agreementDetails,
  onAgreementDetailsUpdated,
  isAgreementTypeOpen,
  agreementExceededGap,
}: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps]);

  const computedValues = useMemo(
    () => getQldAgreementTypeStepCompletionValues(agreementDetails),
    [agreementDetails]
  );

  useEffect(() => {
    if (computedValues.length === 0) {
      return;
    }

    computedValues.forEach((value, index) => {
      const step = taskSteps[index];
      if (!step || step.isCompleted === value) {
        return;
      }

      toggleTaskStep(step.order ?? 0, value);
    });
  }, [computedValues, taskSteps, toggleTaskStep]);

  if (!agreementDetails || !onAgreementDetailsUpdated) {
    return null;
  }

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step2title" color="var(--text-primary)">
        Step 2 : Agreement Type
      </AgxTypography>
      <QLDAgreementTypeStageSteps
        agreementDetails={agreementDetails}
        onAgreementDetailsUpdated={onAgreementDetailsUpdated}
        isOpen={Boolean(isAgreementTypeOpen)}
        exceededGap={Boolean(agreementExceededGap)}
      />
    </AgxSpacer>
  );
};

export default QldAgreementComplianceTypePage;
